// extracted by mini-css-extract-plugin
module.exports = {"container":"_6R7ul4_wdwHfRmJtTCsnC"};